import { render, staticRenderFns } from "./aiyy.vue?vue&type=template&id=09fa9f7a&"
import script from "./aiyy.vue?vue&type=script&lang=ts&"
export * from "./aiyy.vue?vue&type=script&lang=ts&"
import style0 from "./aiyy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports